// import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import * as validateRule from '../../../../components/validateRule.js';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
// import SaveIcon from '@mui/icons-material/Save.js';
import withRouter from '../../withRouter.js';
// import PositiveButton from '../../../atoms/Buttons/PositiveButton.js';
// import Cancel from '@mui/icons-material/Cancel';
import {
  FormControlLabel,
  Radio,
  Typography,
} from '@mui/material';
import {commonOperations} from '../../../../reducks/common/index.js';
// import DangerButton from '../../../atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {renderRadioGroup, renderTextField} from '../../../atoms/CustomPart.js';
import PaperPart from '../../../atoms/PaperPart.js';


const styles = (theme) => ({
  modal: {
    // display: 'absolute',
    // top: '10%',
    // left: '5%',
    // right: '5%',
    // bottom: '5%',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
    // position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    height: 'auto',
    minWidth: '35%',
    // idth: '95%',
    // overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },
  fields: {
    'margin': '15px 10px 15px 10px',
  },

});


class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentBtnDisabled: true,
    };
  }
  closeModal = () => {
    console.log('close');
    this.props.doCloseModal();
  };


  setBtnDisable = (e, o) => {
    if (null === o || o.trim() === '') {
      this.setState({
        commentBtnDisabled: true,
      });
    } else {
      this.setState({
        commentBtnDisabled: false,
      });
    }
  };

  render() {
    // tstkFlag：調査・点検ラジオ選択表示要否 true：表示 false：非表示
    // approvalType：承認・否決区分 1：承認 2：否決
    const {classes,
      openState,
      handleClose,
      handleExec,
      tstkFlag,
      approvalType,
    } = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>コメント</Typography>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid key="comment" item xs={3} sm={12}>
              <Field
                id="comment"
                name="comment"
                multiline={true}
                rows={5}
                variant="outlined"
                component={renderTextField}
                className="fields"
                label="コメント"
                fullWidth
                type="text"
                InputProps={{}}
                required={approvalType==='2'}
                validate={[
                // validateRule.required,
                  validateRule.maxLength(255),
                ]}
                onChange={this.setBtnDisable}
              ></Field>
            </Grid>

          </Grid>
          {tstkFlag &&
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            // spacing={1}
          >
            <Grid key='tsTkSelect' item xs={12} sm={10} direction='row' style={{marginTop: '-15px', marginBottom: '10px'}}>
              <Field
                key='tsTkSelect'
                id='tsTkSelect'
                name='tsTkSelect'
                label=""
                defaultValue={'tsTk'}
                component={renderRadioGroup}
                // onChange={this._handleChangeRadio}
                row
              >

                <FormControlLabel
                  key='tsTk'
                  value='tsTk'
                  control={<Radio />}
                  label='調査・点検'
                />
                <FormControlLabel
                  key='tyoSa'
                  value='tyoSa'
                  control={<Radio />}
                  label='調査'
                />
                <FormControlLabel
                  key='tenKen'
                  value='tenKen'
                  control={<Radio />}
                  label='点検'
                />
              </Field>
            </Grid>
          </Grid>
          }
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="btnCreateComment" item >
              <PositiveButton
                id="btnCreateComment"
                variant="contained"
                // startIcon={<Cancel />}
                size="middium"
                disabled={approvalType==='2' ? this.state.commentBtnDisabled: false}
                onClick={handleExec}
              >
                <span>OK</span>
              </PositiveButton>
            </Grid>
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                // startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>キャンセル</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

Questionnaire.propTypes = {
  classes: PropTypes.object,
  modalInfo: PropTypes.object,
  content: PropTypes.object,
  doCloseModal: PropTypes.func,
  handleClose: PropTypes.func,
  handleExec: PropTypes.func,
  openState: PropTypes.bool,
  tstkFlag: PropTypes.bool,
  approvalType: PropTypes.string,
};

const mapStateToProps = (state) => ({
  modalInfo: state.common.modalInfo,
});

const mapDispatchToProps = {
  doCloseModal: commonOperations.doCloseModal,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Questionnaire)),
);
